<div class="">
    <ng-container *ngIf="templates && templates.length > 0; else showCreateForm">
        <div class="template-card">
            <div class="template-header">
                <h3 class="template-title">Interview Template</h3>
            </div>
            <div class="template-details">
                <p><strong>Previous Role:</strong> {{ templates[0].previousRole }}</p>
                <p><strong>Present Role:</strong> {{ templates[0].presentRole }}</p>
                <p><strong>Previous Client:</strong> {{ templates[0].previousClient }}</p>
                <p><strong>Present Client:</strong> {{ templates[0].presentClient }}</p>
                <p><strong>Interviewing Client:</strong> {{ templates[0].interviewingClient }}</p>
                <p><strong>Job Description:</strong> {{ templates[0].jobDescription }}</p>
            </div>
            <button class="select-btn" (click)="continueToChat(templates[0].id)">Continue to Chat</button>
        </div>
    </ng-container>

    <ng-template #showCreateForm>
        <app-template-form (templateCreated)="onTemplateCreated($event)"></app-template-form>
    </ng-template>
</div>